var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row align-center" }, [
        _c("div", { staticClass: "column small-12 large-10" }, [
          _c(
            "h3",
            { staticClass: "c-heading-large u-color-white text-center" },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.section_title) +
                  "\n            "
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row align-center" }, [
        _c("div", { staticClass: "column small-12 large-10 align-middle" }, [
          _c(
            "div",
            { staticClass: "row small-up-2 medium-up-3 large-up-4" },
            _vm._l(_vm.usps, function(usp) {
              return _c(
                "article",
                {
                  staticClass: "c-card-usp column text-center",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.openReveal(usp)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "c-card-usp-wrapper u-bg-white" }, [
                    usp.single_file
                      ? _c(
                          "figure",
                          { staticClass: "c-figure-usp u-bg-primary" },
                          [
                            _c("img", {
                              staticClass: "c-figure-image",
                              attrs: {
                                src: _vm.changeImageSize(
                                  usp.single_file.media_path,
                                  60,
                                  "_"
                                ),
                                alt: usp.single_file.media_title
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("section", { staticClass: "c-card-usp-section" }, [
                      _c(
                        "p",
                        {
                          staticClass:
                            "c-card-usp-content u-bold u-no-margin-bottom"
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(usp.title) +
                              "\n                            "
                          )
                        ]
                      )
                    ])
                  ])
                ]
              )
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      _vm.show_storage_boxes_reveal
        ? _c("storage-boxes-reveal", {
            on: { closeStorageBoxReveal: _vm.closeStorageBoxReveal }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.show_reviews_reveal
        ? _c("reviews-reveal", {
            on: { closeReviewReveal: _vm.closeReviewReveal }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.show_usp_popup
        ? _c("usp-popup", {
            attrs: { usp: _vm.usp },
            on: { close: _vm.closeUspPopup }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4324e1cd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4324e1cd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/frontend/vue/components/usps/usp-overview.vue
// module id = 248
// module chunks = 3